import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { ISupplierList } from '../../Interfaces/ISupplier'
import { useSupplierData } from '../../Hooks/useSupplierData';
import * as CONSTANTS from '../../Constants'
import { consolelog } from "../../Utils/consolelog";

export interface ISupplierListState {
    suppliers: ISupplierList;
}

export const defaultState: ISupplierListState = {
    suppliers: {list:[], totalCount:0,pageNumber:0, numberOfPageItems:0}
}
// interface SupplierList{
//     type:'SupplierList',
//     payload:ISupplier
// }

// interface Supplier{
//     type:'SupplierList',
//     payload:undefined
// }

// type Action = SupplierList | Supplier

export const supplierReducer = createSlice({
    name: 'SupplierList',
    initialState: defaultState,
    reducers: {
        //setSupplierList: (state, action: PayloadAction<ISupplier>) => {
        setSupplierList: (state, action: PayloadAction<any>) => {
            state.suppliers =  action.payload 
        },
    },
});

const onSuccess = (data:any)=>{
    consolelog('onSuccess callback', data)
}
const onError = (error:any)=>{
    consolelog('onSuccess callback', error)
}

export const { setSupplierList } = supplierReducer.actions;

export const fetchSupplier = (skip:number, take:number) =>
    (dispatch: Dispatch<any>): void => {
    try {
        consolelog('supplierResponse')
        const supplierResponse = useSupplierData(onSuccess, onError,skip,take, CONSTANTS.SERVICES.SUPPLIERS);
        consolelog('supplierResponse',supplierResponse)
        dispatch(setSupplierList(supplierResponse.data))
    } catch (error) {
        consolelog('Error',error)
    }
}

export default supplierReducer.reducer;